import { cn } from "@/lib/utils";

export const SingleBinaryRating = ({
  title,
  up,
  down,
}: {
  title: string;
  up: number;
  down: number;
}) => {
  const empty = up === 0 && down === 0;

  return (
    <div
      className={cn(
        "flex w-full flex-col gap-1 md:flex-row md:items-center md:justify-between md:gap-4",
      )}
      key={title}
    >
      <h4 className={cn("text-sm", empty ? "text-zinc-300" : "text-zinc-950")}>
        {title}
      </h4>
      <div
        className={cn(
          "inline-flex items-center gap-1 text-xs",
          empty && "text-zinc-300",
        )}
      >
        {up > 0 && (
          <div
            className={cn(
              "font-bold whitespace-nowrap",
              up > 0 && "text-remedium-blue",
              up === 0 && "text-zinc-300",
            )}
          >
            Tak
          </div>
        )}
        {down > 0 && (
          <div
            className={cn(
              "font-bold whitespace-nowrap",
              down > 0 && "text-remedium-blue",
              down === 0 && "text-zinc-300",
            )}
          >
            Nie
          </div>
        )}
      </div>
    </div>
  );
};
